import { useEffect } from "react";
import { Link } from "react-router-dom";
import { approach } from "../data/site";
import "./page.css";
import "./home.css";

function About() {
  useEffect(() => {
    document.title = "About · Mirrorkhan Tours";
  }, []);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row mb-4 mb-lg-5">
          <div className="col-lg-8">
            <p className="eyebrow">About</p>
            <h1 className="mb-3">A Tanzania desk with Zanzibar at heart.</h1>
            <p className="page-lead mb-0">
              Mirrorkhan Tours plans private trips across Tanzania, with a clear
              focus on Zanzibar. We keep groups small, choose stays we trust,
              and leave space in the day for the island as it is.
            </p>
          </div>
        </div>

        <div className="row g-4 mb-4 mb-lg-5">
          {approach.map((item, index) => (
            <div className="col-12 col-md-4" key={item.title}>
              <article className="approach-item h-100">
                <span className="approach-item__num">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <h2 className="h4 mb-2">{item.title}</h2>
                <p className="mb-0">{item.text}</p>
              </article>
            </div>
          ))}
        </div>

        <Link className="btn btn-mk-gold" to="/contact">
          Write to the desk
        </Link>
      </div>
    </section>
  );
}

export default About;
